export function detectServerErrorMessage(reason) {

    let message = "خظایی رخ داده، لطفا مجددا تلاش نمایید."

    try {
        const errorCode = getStatusCode(reason)
        console.log("here ", reason.response.data.message)

        if (errorCode === 500) {
            message = "خطایی در سرور رخ داده است، لطفا به مدیر سیستم خود اطلاع دهید."
        } else if (errorCode === 403) {
            message = "دسترسی شما به این صفحه محدود شده است."
        } else {
            if (reason && reason.response && reason.response.data && reason.response.data.message) {
                message= reason.response.data.message
            } else if (reason && reason.response && reason.response.data && reason.response.data.error) {
                message= `${reason.response.data.error} (${reason.response.data.status})`
            } else if (reason && reason.response && reason.response.data && reason.response.data.detail) {
                message= `${reason.response.data.detail} (${reason.response.data.status})`
            } else if (reason && reason.response && reason.response.data && reason.response.data.status === 502) {
                message= "502, خطایی در سرور رخ داده است، لطفا به مدیر سیستم خود اطلاع دهید."
            } else if (reason.response && reason.response.status === 403) {
                message= "دسترسی شما به این صفحه محدود شده است."
            } else {
                message = "خظایی رخ داده، لطفا مجددا تلاش نمایید."
            }
        }

    } catch (e) {
        console.log("error is ", e)
    }

    return message

}


export function getStatusCode(error) {
    if (error && error.response && error.response.data && error.response.data.status) {
        return error.response.data.status
    } else if (error && error.response && error.response.status) {
        return error.response.status
    } else {
        return -1
    }
}